/**
 *
 * When we first start, we create an invoice with Big values etc
 *
 *
 */

export enum CalculationType {
	Rate = 'rate',
	Fixed = 'fixed'
}

export enum TaxType {
	Exclusive = 'exclusive'
}

export enum InvoiceStatus {
	Loading = '',
	Draft = 'draft',
	Sent = 'sent',
	Viewed = 'viewed',
	PartialPaid = 'partial-paid',
	Paid = 'paid',
	Refunded = 'refunded',
	Deleted = 'deleted'
}

export enum PaymentType {
	Manual = 'manual',
	Stripe = 'stripe'
}
export type blah = Record<string, string>

type DataLayerAccount = {
	account_id: string
	account_name: string
	account_email: string
	account_phone: string
	account_created_at: string
	account_created_at_timestamp: number
	account_registered_at: string
	account_registered_at_timestamp: number | null
	account_subscribed: boolean
	intercom_account_hash: string
}

type DataLayerRecord = {
	event: string
	own_stub?: boolean
	stripe_plan_type?: string
	stripe_billing_period?: string
	stripe_transaction_id?: string
}
declare global {
	interface Window {
		dataLayer: (DataLayerRecord | DataLayerAccount)[] | undefined
	}
}

export enum InvoiceStatusFilter {
	All = 'all',
	Unsent = 'unsent',
	Sent = 'sent',
	Paid = 'paid',
	PartialPaid = 'partial-paid',
	Owing = 'owing',
	Overdue = 'overdue',
	Refunded = 'refunded',
	Archived = 'archived'
}

export const invoiceStatusClasses = {
	[InvoiceStatus.Loading]: ['bg-red-100 text-gray-400 border-red-100'],
	[InvoiceStatus.Deleted]: ['bg-red-100 text-gray-400 border-red-100'],
	[InvoiceStatus.Draft]: ['bg-white text-gray-500 border-gray-300'], // aka unsent
	[InvoiceStatus.PartialPaid]: ['bg-yellow-400 text-white border-yellow-400'],
	[InvoiceStatus.Paid]: ['bg-emerald-400 text-white border-emerald-400'],
	[InvoiceStatus.Refunded]: ['bg-red-200 text-gray-400 border-red-200'],
	[InvoiceStatus.Sent]: ['bg-blue-400 text-white border-blue-400'],
	[InvoiceStatus.Viewed]: ['bg-blue-400 text-white border-blue-400']
}

export const getStatusFromString = (s: string): InvoiceStatus => {
	if (s === '') return InvoiceStatus.Loading
	else if (s === 'draft') return InvoiceStatus.Draft
	else if (s === 'sent') return InvoiceStatus.Sent
	else if (s === 'viewed') return InvoiceStatus.Viewed
	else if (s === 'partial-paid') return InvoiceStatus.PartialPaid
	else if (s === 'paid') return InvoiceStatus.Paid
	else if (s === 'refunded') return InvoiceStatus.Refunded
	else if (s === 'deleted') return InvoiceStatus.Deleted
	else return InvoiceStatus.Draft
}

